import { createRpcClientV2 } from 'rpc-client-utils';
import http from 'hub-http/clients/apiClient';
import { getUsagePeriodUsageRpc } from '../../../__generated__/chirp/com/hubspot/usagebasedbilling/experience/rpc/UsageBasedBillingExperienceRpc';
import { convertStringToUnixEpoch, convertToUnixEpoch, getDaysToReset } from './util';
import { checkCreditAuthorizationRpc } from '../../../__generated__/chirp/com/hubspot/enrichment/platform/admin/rpc/EnrichmentPlatformAdminUsageService';
const rpcClient = createRpcClientV2({
  hubHttpClient: http
});

/**
 * @deprecated use fetchHubspotCredits after June 2, 2025
 */
export async function fetchCurrentUsage() {
  const data = await http.get('enrichment-platform-ubb-proxy/v2/usage-period-usage/real-time');
  if (data['@result'] !== 'OK' || !data.recurringUsage) {
    throw new Error('This portal has no usage plan');
  }
  const {
    updatedAt,
    recurringUsage,
    available,
    overage,
    overageEnabled
  } = data;
  return {
    availableCredits: available,
    totalOverage: overage,
    isOverageEnabled: overageEnabled,
    monthlyCredits: {
      totalUsage: recurringUsage.used,
      usageLimit: recurringUsage.limit,
      updatedAt,
      usagePeriod: {
        startDate: convertToUnixEpoch(recurringUsage.startDate),
        endDate: convertToUnixEpoch(recurringUsage.endDate)
      }
    }
  };
}
export async function fetchHubspotCredits() {
  const data = await rpcClient.call(getUsagePeriodUsageRpc, {
    request: {
      showBreakdown: true
    }
  });
  const {
    billingActionDetails,
    breakdown,
    creditsUsed,
    endDate,
    isOverageEnabled,
    overages,
    startDate,
    totalCredits,
    updatedAt
  } = data;
  return {
    availableCredits: Math.max(totalCredits - creditsUsed, 0),
    billingActionDetails,
    isOverageEnabled,
    resetDays: getDaysToReset(endDate),
    totalOverage: overages,
    monthlyCredits: {
      totalUsage: creditsUsed,
      usageLimit: totalCredits,
      updatedAt,
      usagePeriod: {
        startDate: convertStringToUnixEpoch(startDate),
        endDate: convertStringToUnixEpoch(endDate)
      }
    },
    breakdown
  };
}
export async function checkCreditAuthorization({
  action,
  numberOfOperations
}) {
  const data = await rpcClient.call(checkCreditAuthorizationRpc, {
    request: {
      enrichmentType: action,
      numberOfOperations
    }
  });
  return data;
}
export async function checkAllCreditAuthorizations() {
  const numberOfOperations = 1;
  const enrichmentUsage = await checkCreditAuthorization({
    action: 'DATASET_ENRICHMENT',
    numberOfOperations
  });
  const intentMonitoringUsage = await checkCreditAuthorization({
    action: 'INTENT_MONITORING',
    numberOfOperations
  });
  const smartPropertyUsage = await checkCreditAuthorization({
    action: 'SMART_PROPERTY_RUN',
    numberOfOperations
  });
  return {
    DATASET_ENRICHMENT: enrichmentUsage.authorized,
    INTENT_MONITORING: intentMonitoringUsage.authorized,
    SMART_PROPERTY_RUN: smartPropertyUsage.authorized
  };
}